import { useMutation, useQueryClient } from '@tanstack/react-query';

import { executeAutomaticMode } from './accountingPeriod';
import type { AccountingPeriodConfiguration } from './accountingPeriod.types';
import {
  ACCOUNTING_PERIOD_METADATA_KEY,
  ACCOUNTING_PERIODS_KEY,
} from './constants';

export const useUpdateAccountingPeriodMode = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (configuration?: AccountingPeriodConfiguration) =>
      executeAutomaticMode(configuration),
    onSuccess: () => {
      // Invalidate accounting periods queries to refresh the list
      queryClient.invalidateQueries({ queryKey: [ACCOUNTING_PERIODS_KEY] });

      // Also invalidate metadata since automatic mode might affect counts
      queryClient.invalidateQueries({
        queryKey: [ACCOUNTING_PERIOD_METADATA_KEY],
      });
    },
  });
};
